// extracted by mini-css-extract-plugin
export default {"container":"container_HLQCU","OAuthResultMessage":"OAuthResultMessage_WaTaL"};